var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertNewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34323 9.54736L5.85737 5.20486C6.80993 3.55909 7.28652 2.73651 8.00016 2.73651C8.71318 2.73651 9.18894 3.55766 10.1405 5.19997L12.6571 9.54736C13.6134 11.1987 14.0912 12.0244 13.734 12.6439C13.3769 13.2635 12.4225 13.2635 10.5143 13.2635H5.48601C3.57781 13.2635 2.6234 13.2635 2.26626 12.6439C1.90913 12.0244 2.38696 11.1987 3.34323 9.54736ZM8.00016 5.95512C8.2763 5.95512 8.50016 6.17898 8.50016 6.45512V8.9309C8.50016 9.20704 8.2763 9.4309 8.00016 9.4309C7.72402 9.4309 7.50016 9.20704 7.50016 8.9309V6.45512C7.50016 6.17898 7.72402 5.95512 8.00016 5.95512ZM8.002 11.5169C8.40474 11.5159 8.73038 11.1886 8.72935 10.7859C8.72833 10.3831 8.40102 10.0575 7.99829 10.0585C7.59556 10.0595 7.26991 10.3868 7.27094 10.7896C7.27196 11.1923 7.59927 11.5179 8.002 11.5169Z",
    fill: "#F99248"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertNewIcon);
export default ForwardRef;